module.exports = __webpack_public_path__ + "img/managers.5300eddf.svg";